import { Box, Chip, Stack, TextField } from "@mui/material";
import {
  ErrorOutline as ErrorOutlineIcon,
  PhoneIphone as PhoneIphoneIcon,
  Verified as VerifiedIcon,
} from "@mui/icons-material";
import {
  showPhoneNumberChipSx,
  showPhoneNumberChipStatusIconSx,
  showPhoneNumberFieldSx,
  showPhoneNumberIconSx,
  showPhoneNumberStackSx,
} from "./ManagePhone.styles";

const ShowPhoneNumber = ({ phone, phoneVerified }) => (
  <Box>
    <Stack sx={showPhoneNumberStackSx}>
      <PhoneIphoneIcon sx={showPhoneNumberIconSx} />
      <TextField
        variant="outlined"
        label="Teléfono"
        value={phone || "—"}
        InputProps={{ readOnly: true }}
        size="small"
        sx={showPhoneNumberFieldSx}
      />
      <Chip
        icon={
          phoneVerified ? (
            <VerifiedIcon sx={showPhoneNumberChipStatusIconSx} />
          ) : (
            <ErrorOutlineIcon sx={showPhoneNumberChipStatusIconSx} />
          )
        }
        color={phoneVerified ? "success" : "error"}
        label={phoneVerified ? "Verificado" : "Sin verificar"}
        sx={showPhoneNumberChipSx}
      />
    </Stack>
  </Box>
);

export default ShowPhoneNumber;
